var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Info about this speedtest")]),_c('p',[_vm._v(" Your IP address(es): "+_vm._s(_vm.$store.state.ip.info)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }